import React  from "react";
import { connect } from "react-redux";
import TrainingCourseTable from "./components/TrainingCourseTable";



const TrainingCourses = () => {
	return (

    <div>
      <div className="w-full">
          <TrainingCourseTable />
      </div>
    </div>
      
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingCourses);